import { render, staticRenderFns } from "./ListTeams.vue?vue&type=template&id=271e1a18&scoped=true"
import script from "./ListTeams.vue?vue&type=script&lang=ts"
export * from "./ListTeams.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e1a18",
  null
  
)

export default component.exports